export default __webpack_public_path__ + "static/media/Amulet of Good Fortune.82d8fca0.jpg";